class MoneyDisplayController {
  constructor(moneyDisplayFilter, $scope) {
    'ngInject';

    Object.assign(this, { moneyDisplayFilter, $scope });
  }

  $onInit() {
    this.$scope.$watch('$root.currencySymbol', () => this.updateDisplayLabel());
  }

  $onChanges() {
    this.updateDisplayLabel();
  }

  updateDisplayLabel() {
    this.displayLabel = this._getDisplayLabel();
  }

  _getDisplayLabel() {
    if (this.amount == null && this.default != null) {
      return this.default;
    }

    if (this.amount < 0) {
      return `-${this.moneyDisplayFilter(Math.abs(this.amount), !this.short)}`;
    }

    return this.moneyDisplayFilter(this.amount, !this.short);
  }
}

export default {
  template: '<span title="{{ ctrl.displayLabel }}">{{ ctrl.displayLabel }}</span>',
  controller: MoneyDisplayController,
  controllerAs: 'ctrl',
  bindings: {
    amount: '<',
    short: '<?',
    default: '@?',
  },
};
